import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.id = this.el.dataset.countrySelectorId;
    this.endpoint = this.el.dataset.countrySelectorEndpoint;
    this.defaultCountry = this.el.dataset.countrySelectorDefault;

    this.dom = {
      $statesSelector: document._$(`[data-states-selector-id=${this.id}]`)
    };

    if (this.dom.$statesSelector) {
      this.dom.$statesSelector.disabled = true;
      this.dom.$statesSelector.parentNode.classList.remove(
        'form-input--success'
      );
    }

    if (this.defaultCountry) this.el.value = this.defaultCountry;

    this.handleChange(true);
  }

  addListeners() {
    this.el._on('change', this.handleChange.bind(this));
  }

  handleChange(useDefault = false) {
    const value = this.el.value;

    if (value && this.dom.$statesSelector) {
      this.dom.$statesSelector.disabled = true;
      this.dom.$statesSelector.parentNode.classList.remove(
        'form-input--success'
      );
      fetch(`${this.endpoint}?country=${value}`)
        .then(blob => blob.json())
        .then(({ Results }) => {
          if (this.dom.$statesSelector) this.dom.$statesSelector.innerHTML = '';
          Results?.forEach(({ Label: label, Value: value }) => {
            const option = document.createElement('option');
            option.label = label;
            option.textContent = label;
            option.value = value;
            this.dom.$statesSelector.appendChild(option);

            if (
              useDefault ||
              document._$(`[data-states-selector-id=${this.id}]`).dataset
                .useDefault === 'true'
            ) {
              const defaultState = this.dom.$statesSelector.dataset
                ?.defaultState;

              if (defaultState) {
                this.dom.$statesSelector.value = defaultState;
              }
            }
          });

          if (
            !document
              ._$(`[data-states-selector-id=${this.id}]`)
              .hasAttribute('data-use-default')
          ) {
            this.dom.$statesSelector.disabled = false;
            this.dom.$statesSelector.parentNode.classList.add(
              'form-input--success'
            );
            this.dom.$statesSelector.dataset.ready = true;
          }
        });
    }
  }
}

export default Module;
